<template>
  <div class="persona-banner-content">
    <div
      class="persona-banner-image"
      :style="{ backgroundImage: `url(${personaPageStoreBannerImageSrc})` }"
    ></div>
    <div class="persona-overlay-image">
      <h1 class="persona-banner-title">
        {{ personaPageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonaPageMixin from '@/mixins/persona-page-mixin'
import { PersonaPageStore } from '@/store/verbal-identity-page/persona-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonaBannerSection extends Mixins(PersonaPageMixin) {
  personaPageStore: PageStoreContract = getModule(PersonaPageStore, this.$store)

  get personaPageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get personaPageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getPersonaPageStore(): Promise<void> {
    await this.personaPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personaPageStore.isLoading) {
      await this.getPersonaPageStore()
    }
  }
}
</script>

<style lang="scss">
.persona-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.persona-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.persona-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.persona-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
